import React from "react";
import ColorModeToggle from "./ColorModeToggle";
import { useAuth } from "../AuthContext";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
// import Login from "./Login";

export default function Header({ onHeaderClick, currentPath }) {
  const user = useAuth();
  const navigate = useNavigate();
  const handleClick = () => {
    if (currentPath === "/") {
      onHeaderClick?.(); // Safe optional call
    } else {
      navigate("/"); // Go to home page
    }
  };
  return (
    <div className="header-sticky-bar">
    <header className="header">
      <span className="header-brand" onClick={handleClick}>
        Nawa Hub
      </span>
      <nav className="header-nav">
        <ul className="header-nav-list" style={{ alignItems: "center" }}>
          {!user && (
            <li><a href="/login" onClick={(e) => { e.preventDefault(); navigate("/login"); }} className="header-nav-link">Log in / Register</a></li>
          )}
          {user && (
            <>
              <li><a href="/favourites" onClick={(e) => { e.preventDefault(); navigate("/favourites"); }} className="header-nav-link">Favourites</a></li>
              <li><a href="/collections" onClick={(e) => { e.preventDefault(); navigate("/collections"); }} className="header-nav-link">Collections</a></li>
              {user?.email === "iamozthorn@gmail.com" && (
                <li><a href="/admin" onClick={(e) => { e.preventDefault(); navigate("/admin"); }} className="header-nav-link">Admin</a></li>
              )}
              <li onClick={() => { auth.signOut(); navigate("/"); }} className="header-nav-link">Log out</li>
            </>
          )}
          <li><ColorModeToggle /></li>
        </ul>
      </nav>
    </header>
    </div>
  );
}
